import { useContext } from "react"
import { TableContext } from "./TableProvider"

export const useTable = () => {
  return useContext(TableContext)
}
